module.exports = __webpack_public_path__ + "static/media/nHy5Mu5GLe.7cc72b4d.jpg";